export enum attachmentTypeEnum {
  Global = 'G',
  Vessel = 'S',
  Vet = 'V',
  Berth = 'B',
  Company = 'C',
}
